<template>
  <div v-if="data.length > 0" class="file-list">
    <div class="ware-files">
      <div class="ware-file" v-for="(item, index) in data" :key="index">
        <div
          class="ware-file_icon"
          :class="{ ['ware-file_icon-' + item.type]: true }"
        ></div>
        <div class="ware-file_name">
          <span @click="onPreview(item)">{{ item.ware_filename }}</span>
          <a
            class="download"
            @click="onDownload(item)"
            v-if="showDownload && period && period.datum_download == 1"
          >
            <i class="el-icon-download"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Filelist",
  props: {
    showDownload: {
      type: Boolean,
      default: false,
    },
    period: {
      type: Object,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.data = [...value];
        this.getChildren();
      },
    },
  },
  data() {
    return {
      records: [],
      data: [],
    };
  },

  methods: {
    async onDownload(file) {
      if (file.file_url) {
        window.open(file.file_url);
      } else {
        await this.$error("没有文件可下载");
      }
    },
    // async onDownload(item) {
    //   let data = await this.$http.get(
    //     `/api/app/periods/datum/download/${item.datum_id}`,
    //   );
    //   if (data.file_url) {
    //     this.$pub.downloadFile(data.file_url, item.ware_filename);
    //   } else {
    //     await this.$error("没有文件可下载");
    //   }
    // },
    getChildren() {
      this.data.forEach(f => {
        if (
          /\.(wma|mp4|aac|flac|m4a|oga|opus|3gp|mpg|mpeg|3g2|avi|flv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(
            f.ware_filename,
          )
        ) {
          f.type = "video";
        } else if (/\.(doc|docx)$/i.test(f.ware_filename)) {
          f.type = "word";
        } else if (/\.(jpg|png|gif|jpeg|bmp)$/i.test(f.ware_filename)) {
          f.type = "img";
        } else if (/\.(xls|xlsx)$/i.test(f.ware_filename)) {
          f.type = "excel";
        } else if (/\.(pdf)$/i.test(f.ware_filename)) {
          f.type = "pdf";
        } else if (/\.(ppt|pptx)$/i.test(f.ware_filename)) {
          f.type = "ppt";
        } else if (/\.(zip)$/i.test(f.ware_filename)) {
          f.type = "zip";
        } else if (/\.(mp3|wav|wmv)$/i.test(f.ware_filename)) {
          f.type = "audio";
        } else {
          f.type = "file";
        }
      });
    },
    onFileClick(file) {
      if (!file.ware_url) {
        return;
      }
      window.open(file.ware_url);
    },
    async onPreview(file) {
      window.open(file.file_url);

      // if (file.type == "video" || file.type == "audio") {
      //   let data = await this.$http.get(
      //     "/api/app/user/CourseWare/video/preview",
      //     {
      //       video_id: file.fid,
      //     },
      //   );
      //   window.open(data[0].url);
      // } else {
      //   let data = await this.$http.get("/api/app/user/CourseWare/preview", {
      //     fid: file.fid,
      //   });
      //   window.open(data);
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.ware-files {
  padding-right: 20px;
}
.ware-file {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin: 12px 0 0 0;
}
.ware-file_name {
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
  span {
    display: block;
    max-width: 700px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: $primary-color;
    }
  }

  .download {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: $primary-color;
    cursor: pointer;
    margin-left: 10px;
    i {
      margin-right: 6px;
      color: $primary-color;
    }
  }
}
.ware-file_download {
  color: #999;
  cursor: pointer;
}
.ware-file_download-icon {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}
.ware-file_icon {
  width: 26px;
  height: 26px;
  background-size: 100% 100%;
  margin-right: 8px;
  flex-shrink: 0;
}
.ware-file_icon-file {
  background-image: url("~@/modules/stu/images/file/file_icon_3@2x.png");
}
.ware-file_icon-img {
  background-image: url("~@/modules/stu/images/file/image_icon@2x.png");
}
.ware-file_icon-excel {
  background-image: url("~@/modules/stu/images/file/xlsx_icon@2x.png");
}
.ware-file_icon-pdf {
  background-image: url("~@/modules/stu/images/file/pdf_icon@2x.png");
}
.ware-file_icon-ppt {
  background-image: url("~@/modules/stu/images/file/ppt_icon@2x.png");
}
.ware-file_icon-video {
  background-image: url("~@/modules/stu/images/file/video_icon_1@2x.png");
}
.ware-file_icon-word {
  background-image: url("~@/modules/stu/images/file/doc_icon@2x.png");
}
.ware-file_icon-zip {
  background-image: url("~@/modules/stu/images/file/zip@2x.png");
}
.ware-file_icon-audio {
  background-image: url("~@/modules/stu/images/file/audio_icon@2x.png");
}
</style>
